import { observer } from 'mobx-react-lite'

import formPassengersStore from 'entities/ticket/models/form-passengers/form-passengers-store'

import { TicketInsurance } from 'shared/api/avia/insurance'

import { InsuranceServiceEmpty } from '../insurance-service-empty'
import { InsuranceServiceSkeleton } from '../insurance-service-skeleton'
import { InsuranceServicesCard } from '../insurance-services-card'

import s from './styles.module.scss'

export const InsuranceServicesList = observer(() => {
  const insurances = formPassengersStore.ticketInsurances

  const onSelectInsurance = (insurance: TicketInsurance, value: boolean) => {
    if (!value) {
      return formPassengersStore.removeInsurance(insurance.name)
    }
    formPassengersStore.setSelectedInsurance(insurance)
  }

  const renderContent = () => {
    if (!insurances) {
      return Array.from({ length: 2 }).map((_, index) => (
        <InsuranceServiceSkeleton key={index} />
      ))
    }

    if (insurances?.length === 0) {
      return (
        <InsuranceServiceEmpty
          errorMessage={formPassengersStore.insuranceErrorMessage}
        />
      )
    }

    return insurances?.map((item) => (
      <InsuranceServicesCard
        insurance={item}
        key={item.code || item.name}
        onSelectInsurance={onSelectInsurance}
      />
    ))
  }

  return <div className={s.insuranceList}>{renderContent()}</div>
})
